module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row form-horizontal form_importacao"
  }, [_c('div', {
    staticClass: "col-sm-12 form-group"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.analise.length === 0),
      expression: "analise.length === 0"
    }]
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    ref: "fileUpload",
    attrs: {
      "type": "file",
      "id": "fileUpload"
    },
    on: {
      "change": _vm.arquivoAlterado
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.analise.length > 0),
      expression: "analise.length > 0"
    }]
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.limparArquivo($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa fa-repeat",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Trocar o arquivo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 nome_arquivo"
  }, [_vm._v(_vm._s(_vm.nomeArquivo))])])]), _vm._v(" "), (_vm.analise.length > 0) ? _c('div', {
    staticClass: "col-sm-12 resultado_importacao"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("Resultado:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.verificacaoExcel)
    }
  }), _vm._v(" "), (_vm.acaoComplementar && _vm.contadorErrosGerais === 0) ? _c('div', [_c('div', {
    staticClass: "verificacaoALERTA"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.textoAcaoComplementar)
    }
  }), _vm._v(" "), _c('span', {
    ref: "respostaAcaoComplementar"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.opcaoAcaoComplementar(true)
      }
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('g-button-ujarak', {
    attrs: {
      "color": "error"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.opcaoAcaoComplementar(false)
      }
    }
  }, [_vm._v("Não")])], 1)])]) : _vm._e()])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3bf09d1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/importacao/ImportacaoExcel.vue
// module id = 1832
// module chunks = 2